import { Link } from 'gatsby';
import React, { PropsWithChildren } from 'react';

type Props = {
  to: string;
  id?: string;
  className?: string;
  styleClass?: string;
  heightClass?: string;
  target?: string;
};

export const LinkButton: React.FC<Props & PropsWithChildren> = ({
  to,
  id,
  className,
  styleClass,
  heightClass,
  target,
  children,
}) => {
  const newStyleClass =
    styleClass || 'primary-button-bg-color primary-button-color';
  const newHeightClass = heightClass || 'h-10'
  const newTarget = target || 'self'

  return (
    <Link to={to} className="primary-button-color" id={id} target={newTarget}>
      <button
        className={`${newStyleClass} ${className} ${newHeightClass} rounded-[10px] text-base font-semibold border-[1px]`}
        type="submit"
        id={id}
      >
        <span className="">{children}</span>
      </button>
    </Link>
  );
};
